import { IconName } from '@/common/components/Icon/iconName';

export enum ProductDataAccess {
  HideAllDesignData = 0,
  HideModelReports = 1,
  ShowAllData = 2,
}

export enum ProjectDataAccess {
  HideProjectSource = 0,
  ShowAllData = 1,
}

export type DataAccess = ProductDataAccess | ProjectDataAccess;

export interface DataAccessInfo {
  id: DataAccess;
  title: string;
  description: string;
  icon: IconName;
}
